export default "__VITE_ASSET__Cectrpoy__"